const {h, render, Component} = require('preact');

class Acknowledge extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <input type="checkbox" value="true" id="refund-message" name="refund-message" onClick={this.props.handleClick}> </input>
        <label for="refund-message">
          <div class="confirm-message"> {I18n.translate("js.modules.support.refund_confirm_message")}
          </div>
        </label>
      </div>
    )
  }
}

module.exports = Acknowledge